<template>
  <AutoCompleteInput
    v-slot="scope"
    name="instructor"
    :label="$t('product_events.INSTRUCTOR').toString()"
    :list-name="'user'"
    :placeholder="$t('product_events.SEARCH_USER').toString()"
    :value="instructorName"
    :error-message="errors"
    :data-cy="'date-instructor'"
    :no-container="true"
    :options="userSearch"
    class="event-date-form__long-element"
    @changeValueFreeText="changeInstructorFreeText"
    @onKeyUp="searchUsers"
    @optionSelected="selectInstructorByIndex"
  >
    <AutoCompleteOption
      v-for="(user, index) in userSearch"
      :key="user.id"
      :selected="index === scope.activeIndex"
      @optionClicked="changeInstructorOptionValue(user, scope.closeDropdown)"
    >
      <template #title> {{ user.first_name }} {{ user.last_name }} </template>
      <template #details>
        <span v-if="checkStringProperty(user, 'phone_number')">{{
          user.phone_number
        }}</span
        ><span v-if="checkStringProperty(user, 'email')">{{ user.email }}</span>
      </template>
    </AutoCompleteOption>
  </AutoCompleteInput>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import AutoCompleteInput from '@/components/generics/AutoCompleteInput.vue'
import AutoCompleteOption from '@/components/generics/AutoCompleteOption.vue'
import { checkStringProperty } from '@/helpers/stringHelpers.js'
import apiService from '@/service/api.service'

const emit = defineEmits<{
  (
    e: 'changeInstructor',
    instructor: { instructorName: string; instructorId: string }
  ): void
}>()

type InstructorFormElementProps = {
  instructorName: string
  errors: any
}

defineProps<InstructorFormElementProps>()

const userSearch = ref<any[]>([])

const searchUsers = async (query: any) => {
  const userSearchResult = await apiService.getUsersSearch({
    query,
    page: 1,
    per_page: 5,
  })

  userSearch.value = userSearchResult.data.data
}

const changeInstructorFreeText = (instructor: any) => {
  changeInstructor({
    instructorName: instructor.value,
    instructorId: '',
  })
}

const formatInstructorName = (instructor: any) => {
  return `${instructor.first_name || ''} ${instructor.last_name || ''}`
}

const selectInstructor = (instructor: any) => {
  changeInstructor({
    instructorName: formatInstructorName(instructor),
    instructorId: instructor.id,
  })
}

const changeInstructorOptionValue = (
  instructor: any,
  closeHandler: () => void
) => {
  selectInstructor(instructor)
  closeHandler()
}

// The input closes itself after emitting, so this path only resolves the row.
const selectInstructorByIndex = (index: number) => {
  const instructor = userSearch.value[index]
  if (instructor) selectInstructor(instructor)
}

const changeInstructor = (payload: {
  instructorName: string
  instructorId: string
}) => {
  emit('changeInstructor', payload)
}

onMounted(() => searchUsers(''))
</script>
